import { computed } from 'vue';
import { ParameterType } from '@/study-search/enums';
import { KeywordHelperType } from '../../../models/keyword-helper/enums/KeywordHelperType';
import { MappedKeyword } from '../../../models/keyword-helper/enums/MappedHelperKeyword';
import { KeywordHelperDefinitionHelper } from '../../../models/definition/keyword-helper/KeywordHelperDefinitionHelper';
import { KeywordHelperContent } from '../../../models/keyword-helper/KeywordHelperContent';
import getters from '@/study-search/store/getters';
import { PortalType } from '@studyportals/domain-client';

export default class KeywordHelper {
	public KeywordHelperType = KeywordHelperType;

	public helperContent = computed((): KeywordHelperContent | undefined => {
		const definitionHelper = new KeywordHelperDefinitionHelper();
		return definitionHelper.getKeywordContent(this.portalType(), this.keyword());
	});

	private keyword(): MappedKeyword | undefined {
		const keywordWhat = getters.getFilterValues(ParameterType.KEYWORD_WHAT)[0];
		const keywordWhere = getters.getFilterValues(ParameterType.KEYWORD_WHERE)[0];
		if (keywordWhat && keywordWhere) {
			return this.mapFilterToKeyword(keywordWhat + ' ' + keywordWhere);
		}

		if (keywordWhat) return this.mapFilterToKeyword(keywordWhat);
		if (keywordWhere) return this.mapFilterToKeyword(keywordWhere);
	}

	private portalType(): PortalType {
		return getters.getPortalType();
	}

	private mapFilterToKeyword(filterValue: string): MappedKeyword | undefined {
		if (filterValue.toLowerCase().includes('phd')) return MappedKeyword.PHD;
		if (filterValue.toLowerCase().includes('master')) return MappedKeyword.MASTERS;
		if (filterValue.toLowerCase().includes('bachelor')) return MappedKeyword.BACHELORS;
		if (filterValue.toLowerCase().includes('english')) return MappedKeyword.ENGLISH;
	}
}
